import { getCountries, getCountryCallingCode } from "libphonenumber-js";

export type CountryCode = {
    name: string;
    code: string;
    emoji: string;
    dialCode: string;
};

function countryCodeToEmoji(code: string): string {
    return code
        .toUpperCase()
        .split("")
        .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
        .join("");
}

function createCountryCode(code: string, name: string): CountryCode {
    return {
        code,
        name,
        dialCode: `+${getCountryCallingCode(code as Parameters<typeof getCountryCallingCode>[0])}`,
        emoji: countryCodeToEmoji(code),
    };
}

export const gbCountryCode: CountryCode = createCountryCode("GB", "United Kingdom");

export const popularCountryCodes: CountryCode[] = [
    { code: "US", name: "United States" },
    { code: "CA", name: "Canada" },
    { code: "GB", name: "United Kingdom" },
    { code: "DE", name: "Germany" },
    { code: "FR", name: "France" },
    { code: "FI", name: "Finland" },
    { code: "EE", name: "Estonia" },
    { code: "BG", name: "Bulgaria" },
    { code: "LU", name: "Luxembourg" },
    { code: "AE", name: "United Arab Emirates" },
    { code: "SA", name: "Saudi Arabia" },
    { code: "QA", name: "Qatar" },
    { code: "KW", name: "Kuwait" },
    { code: "BH", name: "Bahrain" },
    { code: "OM", name: "Oman" },
].map(({ code, name }) => createCountryCode(code, name));

export const countryCodes: CountryCode[] = getCountries().map((code) =>
    createCountryCode(code, code),
);
